import React from "react";
import { Link, useNavigate } from "react-router-dom";
import menuItems from "./const/menuItems.json";

export const Navbar = () => {
  const isAuthenticated = !!localStorage.getItem("token");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const items = isAuthenticated ? menuItems.private : menuItems.public;

  return (
    <nav className="border-b border-gray-300 p-4">
      <ul className="flex justify-end space-x-4 px-4">
        {items.map((item, index) => (
          <li key={index}>
            <Link to={item.path} className="text-gray-900">
              {item.name}
            </Link>
          </li>
        ))}

        {isAuthenticated && (
          <li>
            <button onClick={handleLogout} className="text-gray-900">
              Cerrar sesión
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};
